import { useState } from 'react';

interface ReviewSubmitButtonProps {
  onSubmit: () => Promise<void>;
  disabled?: boolean;
  isValid: boolean;
  className?: string;
}

export function ReviewSubmitButton({ 
  onSubmit, 
  disabled = false, 
  isValid,
  className = "" 
}: ReviewSubmitButtonProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (disabled || !isValid || isSubmitting) return;

    setIsSubmitting(true);
    try {
      await onSubmit();
    } catch (error) {
      console.error('Review submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isButtonDisabled = disabled || !isValid || isSubmitting;

  return (
    <button
      onClick={handleSubmit}
      disabled={isButtonDisabled}
      className={`
        w-full py-4 px-6 rounded-xl font-semibold text-lg
        transition-all duration-200
        ${isButtonDisabled
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-green-500 text-white hover:bg-green-600 active:bg-green-700'
        }
        ${isSubmitting ? 'opacity-75' : ''}
        ${className}
      `}
    >
      {isSubmitting ? (
        <div className="flex items-center justify-center gap-2">
          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>리뷰 등록 중...</span>
        </div>
      ) : (
        '리뷰 등록하기'
      )}
    </button>
  );
}